import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';


import {
  AnalyticsService, CommentService, DownloadService,
  // Services
  HttpService,
  InternalLinkService, NgAnalyticsService, NgCommentService, NgDownloadService, NgHttpService,
  NgInternalLinkService, NgNotificationService, NgParamService, NgPostTypeProvider, NgPreferenceService, NgRefreshService,
  NgToastService, NotificationService, ParamService, PostLikeService, PreferenceService, RefreshService,
  // Functions
  throwIfAlreadyLoaded, ToastService,
  // Providers
  WordpressPostTypeProvider
} from 'projects/business/src/public-api';


// Plguins
import { PreviewAnyFile } from '@awesome-cordova-plugins/preview-any-file/ngx';


import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { LeaveRequestService } from 'projects/business/src/lib/services/leave-request.service';


export const PROVIDERS = [
    { provide: NgPostTypeProvider, useClass: WordpressPostTypeProvider },
];


export const SERVICES = [
    { provide: NgHttpService, useClass: HttpService },
    { provide: NgInternalLinkService, useClass: InternalLinkService },
    { provide: NgRefreshService, useClass: RefreshService },
    { provide: NgToastService, useClass: ToastService },
    { provide: NgAnalyticsService, useClass: AnalyticsService },
    { provide: NgParamService, useClass: ParamService },
    { provide: NgDownloadService, useClass: DownloadService },
    { provide: NgNotificationService, useClass: NotificationService },
    { provide: NgPreferenceService, useClass: PreferenceService },
    { provide: NgCommentService, useClass: CommentService },
    { provide: LeaveRequestService, useClass: LeaveRequestService },
    { provide: PostLikeService, useClass: PostLikeService },
];


export const PLUGINS = [
  { provide: PreviewAnyFile, useClass: PreviewAnyFile },
];


@NgModule({
    imports: [
      CommonModule,
      FontAwesomeModule
    ]
})
export class BusinessModule {
    constructor(@Optional() @SkipSelf() parentModule: BusinessModule, library: FaIconLibrary) {
        throwIfAlreadyLoaded(parentModule, 'BusinessModule');
        library.addIconPacks(far);
    }

    static forRoot(): ModuleWithProviders<BusinessModule> {
        return {
            ngModule: BusinessModule,
            providers: [
                ...PROVIDERS,
                ...SERVICES,
                ...PLUGINS
            ],
        } as ModuleWithProviders<BusinessModule>;
    }
}
